import { render, staticRenderFns } from "./TemplateMessageTextCounter.vue?vue&type=template&id=5ab9e9f6"
import script from "./TemplateMessageTextCounter.vue?vue&type=script&lang=js"
export * from "./TemplateMessageTextCounter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports